import { ref } from 'vue'
// tabbar页面
export const TABBER_PAGE = [
  'pages/index/index',
  'pages/activity/index',
  'pages/mine/mine',
  'pages/recommend/index',
  'pages/game/game',
]

// 如果页面不是 tabbar 页面就隐藏 tabbar
export const hideTabbar = ref(false)
export function currentPageIsTabbar(page?: string) {
  // 如果没有传 page，取当前页面
  if (!page) {
    page = getCurrentPages()[getCurrentPages().length - 1].route
  }
  hideTabbar.value = TABBER_PAGE.includes(page)
  return TABBER_PAGE.includes(page)
}
